import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, doc, writeBatch } from "firebase/firestore";
import { getStorage, ref } from "firebase/storage";
// import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth, getIdToken } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  // measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

export const initFirebase = () => {
  const currentApps = getApps();
  if (typeof window === "undefined" || currentApps.length !== 0) return;
  const app = initializeApp(firebaseConfig);

  // const domain = new URL(window.location.href).host;
  // if (domain === "localhost:3000") return console.log("dev mode.");

  // const reCaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
  // self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  // if (reCaptchaSiteKey)
  //   initializeAppCheck(app, {
  //     provider: new ReCaptchaV3Provider(reCaptchaSiteKey),
  //     isTokenAutoRefreshEnabled: true,
  //   });
  if (typeof window !== "undefined" && "measurementId" in firebaseConfig)
    getAnalytics(app);
};

export const getDb = () => getFirestore(getApp());
export const getRef = (collectionName: string, path: string) =>
  doc(collection(getDb(), collectionName), path);
export const getBatch = () => writeBatch(getDb());
export const getStorageRef = (path: string) => ref(getStorage(getApp()), path);
export const getApiToken = async () =>
  await getIdToken(getAuth().currentUser!, true);
